export enum GlobalSearchCategoriesEnum {
  products = 'products',
  orders = 'orders',
  features = 'features',
  customers = 'customers',
  appMarket = 'appMarket',
  globalSearch = 'globalSearch',
}
